import { SxProps, Theme } from "@mui/material/styles";
import * as Global from "styles/global/global.styles";

export function cardCSS(theme: Theme): SxProps<Theme> {
  return {
    // my: "50px",
    // mx: "15rem",
    px: "4rem",
    py: "20px",
    borderRadius: "30px",
    width: { xs: "200px", md: "500px", lg: "600px" },
  };
}

export function containerCSS(theme: Theme): SxProps<Theme> {
  return {
    backgroundColor: { xs: "#F9F9F9", sm: "transparent" },
    px: { xs: "1rem", sm: "3rem", md: "0", lg: "3rem" },
    maxWidth: { xs: "390px", sm: "500px", md: "550px" },
  };
}

export function titleCSS(theme: Theme): SxProps<Theme> {
  return {
    textAlign: "center",
  };
}

export function buttonContainerCSS(theme: Theme): SxProps<Theme> {
  return {
    display: "flex",
    flexDirection: { xs: "column-reverse", sm: "row" },
    justifyContent: { xs: "space-between", sm: "space-around" },
    gap: "1rem",
    my: "2rem",
  };
}

export function buttonCSS(theme: Theme, buttonName: string): SxProps<Theme> {
  return {
    width: { xs: '100%', sm: '130px' },
		height: { xs: '8vh', sm: '40px' },
    borderRadius: "100px",
    backgroundColor: buttonName === "previous" ? "#006490" : "primary",
  };
}

export function downloadButtonCSS(theme: Theme): SxProps<Theme> {
  return {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    border: "2px solid #efefef",
    borderRadius: "10px",
    backgroundColor: "#efefef",
    margin: "5px 0",
    py: '10px',
    px: "15px",
	justifyContent:'space-between',
	mb: '1rem'
  };
}

export function downloadFilesCSS(theme: Theme): SxProps<Theme> {
    return {
        display: "flex",
        // gap: "1rem",
        alignItems: "center",
        justifyContent: "start",
        mb: 0,
        pb: 0,
        width: "100%",
    };
}

export function closeDialogIconButton(theme: Theme): SxProps<Theme> {
    return {
        position: "absolute",
        right: 8,
        top: 8,
        color: "grey",
        marginTop: "4px"
    };
}

export function statusDialogTitle(theme: Theme): SxProps<Theme> {
    return {
        m: 0,
        p: 2
    };
}